import { HomePageContextProvider, TravelHomePage, TravelShowPage } from 'components';
import { ProtectedRoute } from 'router';

export const travelRoutes = {
  travelHomePage: {
    path: '/voyages-sejours',
    component: () => (
      <ProtectedRoute>
        <HomePageContextProvider>
          <TravelHomePage />
        </HomePageContextProvider>
      </ProtectedRoute>
    )
  },
  travelShow: {
    path: '/voyages-sejours/:id',
    component: () => (
      <ProtectedRoute>
        <HomePageContextProvider>
          <TravelShowPage />
        </HomePageContextProvider>
      </ProtectedRoute>
    )
  }
};
